<template>
  <div class="main-index">
    <div class="api-content">
      <div class="api-item" v-for="(item, index) in list" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
        <div class="try-button"  @click.stop="goLink(item.link)">去试用</div>
      </div>

      <div class="group-title">小梵系列API组件</div>

      <div class="api-item" v-for="(item, index) in list2" :key="'2'+index">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
        <div class="try-button" @click.stop="goLink(item.link)">去试用</div>
      </div>
      <a class="api-go" href="/openplat-front/serviceProductAll">进入组件集市>></a>
    </div>
  </div>
</template>
<script>
export default {
  name: "apiActivity",
  data() {
    return {
      list: [
        {
          title: "慧营 · 数智营销平台",
          desc:
            "慧营以用户为中心，基于大数据平台的客户身份信息、交易数据、行为数据基础，融合全流程、多渠道营销服务需求。建立了一套营销闭环流程：包括营销规划、内容创作、目标筛选、策略执行、效果追踪等环节，解决客户引入、留存、转化及运营效率提升等问题。",
          link:'https://www.hs.net/openplat-front/service/serviceDetail/1444'
        },
        {
          title: "i私募运营通（CBS）双录服务",
          desc:
            "​i私募运营通（CBS）双录服务 - 券商标准的在线双屏双录，实时上传，支持随时随地在线查看和下载，20年存储不用愁。",
          link:'https://www.hs.net/openplat-front/service/serviceDetail/1076'
        },
        {
          title: "i私募电子签约服务",
          desc:
            "i私募电子签基于区块链和密码学技术打造，依托区块链联盟，为用户提供中立、合法、可信、可靠的第三方电子合同签约服务平台，并提供合同存证公证出证一站式服务；为私募行业专门定制的标准化、流程化全程线上签约。",
            link:'https://www.hs.net/openplat-front/service/serviceDetail/1283'
        },
        {
          title: "智眸风险预警",
          desc:
            "智眸风险预警平台是全市场风险预警系统，通过部署客户本地对接客户持仓，多维度视角监控持仓风险，包含舆情、财务附注、城投专题、诚信大数据等特色数据，内置财务诊断、债券违约等风险模型，支持客户定制化需求。",
            link:'https://www.hs.net/openplat-front/service/serviceDetail/1303'
        }
      ],
      list2: [
        {
          title: "小梵基金F10",
          desc:
            "基金F10功能主要从单个基金、基金公司及基金经理三个维度进行深度的数据展示。重点展示基金经理、投资组合、基金净值变化等数据；从基金业绩和基金经理的排名到基金净值变化，全方位、多角度反映基金的投资特点。",
            link:'https://www.hs.net/openplat-front/service/serviceDetail/1605'
        },
        {
          title: "小梵ETF专题",
          desc:
            "对ETF进行分类，通过主题关联、新发专区、广告运营等方式提高拓展性。",
            link:'https://www.hs.net/openplat-front/service/serviceDetail/1593'
        },
        {
          title: "小梵新发基金",
          desc:
            "从新发基金基本信息、基金经理投资能力、基金公司介绍三维度全面分析新发基金，帮助用户快速掌握基金详细信息。",
            link:'https://www.hs.net/openplat-front/service/serviceDetail/1587'
        },
        {
          title: "小梵主题基金",
          desc:
            "主题选基包涵超240种热门概念主题，快速筛选当下最热门基金，内容持续迭代，帮助投资者精准定位投资主题，把握市场热点。",
            link:'https://www.hs.net/openplat-front/service/serviceDetail/1585'
        }
      ]
    };
  },
  methods: {
    goLink(url) {
      // debugger
      location.href=url
      // window.open(url)
    }
  }
};
</script>
<style lang="scss" scoped>
.main-index {
  width: 100%;
  background: url("../../../assets/activity/bg.png");
  padding-top: 400px;
  padding-bottom: 100px;
  background-size: cover;
  background-position: 0 50%;
}
.api-content {
  background: rgba(255, 255, 255, 0.3);
  border: 3px solid rgba(255, 255, 255, 1);
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 20px;
}
.api-item {
  background-image: linear-gradient(135deg, #ebf4ff 0%, #f2f9ff 100%);
  box-shadow: 4px 4px 10px 0px rgba(195, 216, 239, 1);
  border-radius: 8px;
  width: 540px;
  height: 212px;
  margin: 20px;
  padding: 20px;
  position: relative;
  .title {
    // font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    line-height: 20px;
    margin-bottom: 16px;
    font-weight: bold;
  }
  .desc {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 8px;
  }
  .try-button {
    background-image: linear-gradient(180deg, #608eff 0%, #1b5dff 100%);
    border-radius: 16px;
    width: 113px;
    height: 32px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
  }
}
.group-title {
  font-family: PingFangSC-Medium;
  font-size: 26px;
  color: #333333;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: bold;
  width: 1120px;
  padding-left: 4px;
  border-left: 6px solid #004cff;
  margin-top: 40px;
}
.api-go {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #666666;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 500;
  width: 1120px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/apiActivity/apiActivity.vue